// Vendors
import React from 'react';
// Components
import { LoadingComponent } from 'components/loading/loading.component';
// Constants
import { GET_STATE_LOADER_COMPONENT_PROPS } from './constants/get-state.constants';
// Hooks
import { useGetStateHook } from './hooks/get-state.hook';
// Styles
import { HeaderLayoutContentFullHeightStyled } from 'styles/app.styled';

const GetStateContainer = (): React.JSX.Element => {
  useGetStateHook();

  return (
    <HeaderLayoutContentFullHeightStyled>
      <LoadingComponent {...GET_STATE_LOADER_COMPONENT_PROPS} />
    </HeaderLayoutContentFullHeightStyled>
  );
};

export { GetStateContainer };
